<template>
    <nav>
        <div class="row">
            <div class="col-sm-6">
                <div class="">
                    <label>Station Group</label>
                    <select class="form-select form-select-sm station_wise_select" v-model="selectedStationGroupId">
                        <option :value="null">All Groups</option>
                        <option v-for="stationGroup in StationGroup" :value="stationGroup.id" :key="stationGroup.id">{{ stationGroup.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="">
                    <label>Station</label>
                    <select class="form-select form-select-sm station_wise_select" v-model="selectedStationId">
                        <option :value="null">All Stations</option>
                        <option v-for="station in filteredStations" :value="station.id" :key="station.id">{{ station.name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import StationService from '../../../services/StationsService';

    export default {
        name: "ReportFiltersForStationWiseReport",
        data: () => ({
            StationGroup:[],
            allStations:[],
        }),
        computed: {

            // F-03: station group is now backed by Vuex so the report request can
            // carry it. Selecting a group resets the station to "All" so the report
            // shows the whole group's aggregate (the station filter then narrows it).
            selectedStationGroupId: {
                get() {
                    return this.$store.state.reportPageFilters.selectedStationGroupId;
                },
                set(stationGroupId) {
                    this.$store.dispatch('selectedStationGroupId', stationGroupId);
                    this.$store.dispatch('selectedStationId', null);
                }
            },

            selectedStationId: {
                get() {
                    let selectedStationIdCheck = this.$store.state.reportPageFilters.selectedStationId;
                    return  selectedStationIdCheck === null ? null : selectedStationIdCheck;
                },
                set(stationId) {
                    this.$store.dispatch('selectedStationId', stationId);
                }
            },

            filteredStations() {
                const vm = this;
                if(vm.selectedStationGroupId == null || vm.selectedStationGroupId == 0){
                    return vm.allStations;
                }
                return vm.allStations.filter(function (station) {
                    return station.station_group.id === vm.selectedStationGroupId;
                });
            },
            selectedStation(){
                const vm = this;
                return vm.allStations.find(station => station.id === vm.selectedStationId);
            },
        },
        // F-03: auto-select-first watchers removed. Filters default to "All" so the
        // report can render a group/all-stations aggregate without forcing a machine.
        methods: {
            // stationChanged() {
            //     if(this.selectedStation){
            //         this.selectedStationGroupId = this.selectedStation.station_group.id;
            //     }
            //     this.$emit('stationChanged', {
            //         'stationId': this.selectedStationId,
            //         'station': this.selectedStation
            //     });
            // },
        },
        mounted() {
            StationService.fetchAllGroups( response => {
                this.StationGroup = response;
            });
            StationService.fetchAll([], response => {
                this.allStations = response;
            });
        }
    }
</script>

